import { apiRequest } from "./client";

export const usersApi = {
  list(params = {}) {
    const search = new URLSearchParams();
    if (params.status) search.set("status", params.status);
    if (params.search) search.set("search", params.search);
    if (params.order) search.set("order", params.order);
    if (params.page) search.set("page", String(params.page));
    if (params.limit) search.set("limit", String(params.limit));
    if (params.createdFrom) search.set("createdFrom", String(params.createdFrom));
    if (params.createdTo) search.set("createdTo", String(params.createdTo));
    const query = search.toString();
    return apiRequest(`/users${query ? `?${query}` : ""}`);
  },

  approve(userId, payload = {}) {
    return apiRequest(`/users/${userId}/approve`, {
      method: "PATCH",
      body: JSON.stringify(payload),
    });
  },

  suspend(userId) {
    return apiRequest(`/users/${userId}/suspend`, {
      method: "PATCH",
    });
  },
};
